import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { Box } from '@app/definitions/interfaces';
import { MAIN_DOMAIN } from '@app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class PrepareBoxService {
    public boxChanged = new EventEmitter<Array<Box>>();
    public selectedBox = new EventEmitter<Box>();
    public oneBoxChange = new EventEmitter<Box>();
    public sBox: Box;
    private boxes: Array<Box> = [];

    constructor(private http: HttpClient) {
        this.oneBoxChange.subscribe(box => {
            this.removeBoxId(box);
        });
    }

    public deleteTaskBox(lesson_id: string): Observable<any> {
        return this.http.delete<any>(`${MAIN_DOMAIN}/api/tasks/box/delete/${lesson_id}/`);
    }

    getBoxes(): Array<Box> {
        if (this.boxes) {
            return this.boxes.slice();
        }
        return null;
    }

    setBoxes(boxes: Array<Box>) {
        this.boxes = boxes.slice();
        this.boxChanged.emit(this.getBoxes());
    }

    addBox(box: Box) {
        if (this.boxes === null || this.boxes === undefined) {
            this.boxes = [];
        }
        this.boxes.push(box);
        this.boxChanged.emit(this.getBoxes());
    }

    removeBox(box: Box) {
        this.boxes.splice(this.boxes.indexOf(box), 1);
        this.boxChanged.emit(this.getBoxes());
    }

    setSelected(box: Box) {
        this.sBox = box;
        this.selectedBox.emit(box);
    }

    boxChange(box: Box) {
        this.boxes[this.boxes.indexOf(this.sBox)] = box;
        this.boxChanged.emit(this.getBoxes());
        this.oneBoxChange.emit(box);
    }

    removeBoxId(box: Box) {
        if (box.id) {
            box.id = null;
            this.oneBoxChange.emit(box);
        }
    }

    deselectBox() {
        this.sBox = null;
        this.selectedBox.emit(null);
    }

    public emitBoxChanged(box?: any): void {
        if (box) {
            this.oneBoxChange.emit(box);
        }
        this.boxChanged.emit(this.getBoxes());
    }

    changeBoxTitle(new_title: string, old_title: string) {
        if (this.boxes) {
            for (const b of this.boxes) {
                if (b.title === old_title) {
                    b.title = new_title;
                }
            }
        }
    }
}
